import { TResponse } from '../basis/types/tresponse';
import { axiosGet, axiosPost } from '../utils/axios';

// 上传日志文件
export const uploadLogFile = async (data: FormData) => {
  const resp = await axiosPost<TResponse.Result>(`/mgr/v1/log/upload`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return resp;
};

// 获取服务编码
export const getLicenceSign = async () => {
  const resp = await axiosGet<TResponse.Result>(`/mgr/v1/licence/sign`);

  return resp;
};
